import { TableCellComponentProps, LinkCellValue } from '@/shared/types/table';
import { cn } from '@/shared/utils/cn';
import { TruncatedWithTooltip } from '@/modules/Tooltip';
import {
  getTableCellClasses,
  getTableCellProps,
  handleCellClick,
  getContentAlignClass,
  isFlexColumn,
} from '../../utils/cellStyles';

export const LinkCell = ({
  value,
  row,
  column,
  state = 'default',
  className,
  onCellFocus,
  stickyLeft = 0,
  isLastLocked = false,
  isRowEditing,
  hasColumnMaxWidthAuto = false,
}: TableCellComponentProps) => {
  const baseClasses = getTableCellClasses(
    state,
    className,
    column.locked,
    isLastLocked,
    undefined,
    isRowEditing,
    false,
    column.width !== undefined || isFlexColumn(column, hasColumnMaxWidthAuto)
  );
  const cellProps = getTableCellProps(column, stickyLeft, undefined, false, hasColumnMaxWidthAuto);

  // Alineamiento del contenido
  const alignClass = getContentAlignClass(column.contentAlign);

  const hasFixedWidth = column.width !== undefined || isFlexColumn(column, hasColumnMaxWidthAuto);
  const linkClasses = cn(
    'ui-text-link hover:ui-text-link-hover ui-underline ui-cursor-pointer',
    'ui-text-sm',
    'ui-transition-colors ui-duration-150',
    hasFixedWidth && 'ui-truncate ui-block ui-min-w-0',
    state === 'disabled' && 'ui-pointer-events-none ui-opacity-50'
  );

  const isObject = value && typeof value === 'object' && !Array.isArray(value);
  const linkValue = isObject ? (value as LinkCellValue) : null;
  const href = linkValue?.href ?? '#';
  const label =
    linkValue?.label ??
    (typeof value === 'string' || typeof value === 'number' ? value : (linkValue?.href ?? ''));

  return (
    <td className={baseClasses} {...cellProps} onClick={(e) => handleCellClick(e, onCellFocus)}>
      <div
        className={cn(
          'ui-flex ui-h-full ui-items-center',
          alignClass,
          hasFixedWidth && 'ui-min-w-0 ui-overflow-hidden'
        )}
      >
        <a href={href} className={linkClasses} target="_blank" rel="noopener noreferrer">
          <TruncatedWithTooltip
            truncate={hasFixedWidth}
            title={typeof label === 'string' ? label : String(label)}
          >
            {label}
          </TruncatedWithTooltip>
        </a>
      </div>
    </td>
  );
};
